module.exports = __webpack_public_path__ + "img/popup_window_song.08f1e1b7.png";